/* eslint-disable max-len */

export const MC_PLAN_COMPARISON = [
  {
    featureTitle: 'Email Marketing',
    subFeatures: [
      {
        name: 'Design & Code Editors',
        tooltip:
          'Create emails using HTML code, drag & drop editing, or a mix of both.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Segmentation',
        tooltip:
          'Target audiences based on your custom field data or our email engagement data.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'A/B Testing & Actionable Insights',
        tooltip:
          'Test multiple subject lines and content variations within a single send and access analytics reports to learn from engagement and recipient data.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Email Testing',
        tooltip:
          'Run spam tests, preview how your email renders, and validate links within your editing workflow.',
        free: '3 credits',
        basic: '10 credits\nMore for purchase',
        advanced: '60 credits\nMore for purchase',
      },
      {
        name: 'Signup Forms',
        tooltip:
          'Grow your contact list with a simple signup form you can embed on your website or share as a Twilio SendGrid hosted link.',
        free: '1 form',
        basic: '5 forms',
        advanced: '15 forms',
      },
      {
        name: 'Automation',
        tooltip:
          'Send automated emails or time-based drip series using triggers you already have in place.',
        free: true,
        basic: false,
        advanced: true,
      },
      {
        name: 'Dedicated IP Included',
        tooltip:
          'Own your reputation with a dedicated IP address, and then automate your IP warmup.',
        free: false,
        basic: false,
        advanced: true,
      },
      {
        name: 'Access to Additional IPs',
        tooltip: 'Purchase and manage additional IP addresses.',
        free: false,
        basic: false,
        advanced: true,
      },
      {
        name: 'Send scheduling',
        tooltip:
          'Schedule emails to send immediately or at a pre-scheduled date and time.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Content Personalization',
        tooltip:
          'Customize subject lines and email content for each individual recipient using custom field data.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Unsubscribe Groups',
        tooltip:
          'Support recipient preferences and remain compliant with tools to manage opt-outs.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Responsive Templates',
        tooltip:
          'Use pre-built templates that dynamically render across device types.',
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Analytics & Reporting',
    subFeatures: [
      {
        name: 'Engagement Statistics',
        tooltip:
          'See key engagement data like delivery, click, open, and unsubscribe rates.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Link Click Tracking',
        tooltip:
          'See which links within each email are the most compelling to readers.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Bounce Rate, Spam, Blocked Reporting',
        tooltip:
          'Gain timely insight into events that may cause delivery issues.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Application, Device, Browser, and Mailbox Usage',
        tooltip:
          'See the email applications, devices, browsers, and mailbox providers your recipients use as they engage with email.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Geographical Distribution',
        tooltip:
          'Determine where recipients are located as they engage with your email.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Email Category Comparison',
        tooltip:
          'Use categories to run custom analytics across different types of email you send.',
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Deliverability',
    subFeatures: [
      {
        name: 'Inbox Provider Relationships',
        tooltip: 'Benefit from our proactive ISP monitoring and outreach.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Built-In Best Practices',
        tooltip:
          'Use in-app tools like Sender Profiles and Unsubscribe Groups to help support your deliverability.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Authentication',
        tooltip:
          'Increase email deliverability and trust with authenticated domains and branded links.',
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Support & Expertise',
    subFeatures: [
      {
        name: 'Technical Support',
        tooltip:
          'Reach out to our support team for actionable recommendations.',
        free: 'Ticket support',
        basic: 'Ticket &\n chat support',
        advanced: 'Ticket, chat, &\nphone support',
      },
      {
        name: 'Personalized Support',
        tooltip:
          'Add a technical account manager to your team for the highest level of proactive technical support.',
        free: false,
        basic: 'Available\nfor purchase',
        advanced: 'Available\nfor purchase',
      },
      {
        name: 'Guaranteed Support Response Times',
        tooltip:
          'Gain peace of mind with guaranteed response times by incident priority.',
        free: false,
        basic: 'P1: 3 business hrs\nP2: 6 business hrs\nP3: 9 business hrs',
        advanced: 'P1: 1 hr (24/7)\nP2: 2 business hrs\nP3: 3 business hrs',
      },
      {
        name: 'Expert Services',
        tooltip:
          'Add an email expert to your team to help you build a strong sender reputation and optimize your strategy as you grow.',
        free: false,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Integration & Customization',
    subFeatures: [
      {
        name: 'Marketing Campaigns APIs',
        tooltip:
          'Manage Marketing Campaigns programmatically with Contact, Sender, and Single Send APIs.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Event Webhook',
        tooltip:
          'Absorb events from your Twilio SendGrid account to create a customized analytics dashboard, set up triggered email campaigns, and insert dynamic data.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Subuser API',
        tooltip:
          'Divide email traffic across Subusers within your account through the API for independent analysis or reputation management.',
        free: false,
        basic: false,
        advanced: true,
      },
      {
        name: 'Universal Links',
        tooltip:
          "Enhance email recipients' mobile experience and maintain click tracking with deep link configuration.",
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Account & Team Management',
    subFeatures: [
      {
        name: 'Teammate Permissions',
        tooltip:
          'Allow multiple users to send from the same account by defining distinct feature access per user.',
        free: '1 Teammate',
        basic: '1 Teammate',
        advanced: '1,000 Teammates',
      },
      {
        name: 'Subuser Management',
        tooltip:
          'Segment your sending, assign permissions and credit limits, as well as view separate statistics programmatically or in the UI.',
        free: false,
        basic: false,
        advanced: true,
      },
      {
        name: 'Access to Transactional Templates',
        tooltip:
          'View and manage templates used for email sent via the Email API.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'Email API Statistics',
        tooltip: 'View and analyze data for emails sent via the Email API.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'API Key Permissions',
        tooltip:
          'Uniquely set API keys with admin, read-only, or precise access settings by feature to limit your exposure to risk.',
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
  {
    featureTitle: 'Privacy & Security',
    subFeatures: [
      {
        name: 'Two-Factor Authentication',
        tooltip:
          'Require authentication beyond a username and password when logging into your account.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'IP Access Management',
        tooltip:
          'Whitelist IP addresses so only your account users can access your account.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'TLS Encryption',
        tooltip:
          'Increase the security of your emails by using opportunistic or enforced TLS secure protocols.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'SOC 2 Type II Certification',
        tooltip:
          'Safeguard your data with Twilio SendGrid, which has been certified by recognized industry organizations for its rigorous controls.',
        free: true,
        basic: true,
        advanced: true,
      },
      {
        name: 'GDPR Compliance',
        tooltip:
          'Maintain the highest privacy and data protection with our GDPR compliance.',
        free: true,
        basic: true,
        advanced: true,
      },
    ],
  },
];

export const EI_PLAN_COMPARISON = [
  {
    featureTitle: 'Straightforward Integration',
    subFeatures: [
      {
        name: 'SMTP and API',
        tooltip:
          'Use our RESTful APIs that are built on HTTP and return JSON for clear implementation.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Interactive API Docs',
        tooltip:
          'Expedite end-to-end integration time with our robust and interactive API documentation.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Setup Guide',
        tooltip:
          'Follow a step-by-step setup guide to integrate and test via SMTP or API including each of our 7 code language snippets.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Comprehensive Client Libraries',
        tooltip:
          'Code in your preferred language with open source libraries and use cases in Node.JS, Ruby, Python, Go, PHP, Java, and C#.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Knowledge Center',
        tooltip:
          'Learn how to use Twilio SendGrid products quickly with concise how-to articles, step-by-step instructions, and quick videos.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Technical Support',
        tooltip:
          'Get answers from our knowledgeable 24/7 support and customer success teams who can provide actionable recommendations.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
    ],
  },
  {
    featureTitle: 'Trusted Deliverability & Performance',
    subFeatures: [
      {
        name: 'Purpose-Built Mail Transfer Agent',
        tooltip:
          'Expand your reach with powerful performance from our custom MTA, proven at scale.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Email Address Validation API',
        tooltip:
          'Protect your sending reputation by validating email addresses before you send to them with SendGrid’s real-time Email Validation API.',
        free: false,
        essentials: false,
        pro: '2,500 Validations',
        premier: '5,000 Validations',
      },
      {
        name: 'Globally Distributed Architecture',
        tooltip:
          'Rely on our cloud-based, redundant infrastructure with a 99.999% uptime.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Reputation & Delivery Visibility',
        tooltip:
          'Know where your program stands with reputation monitoring, delivery event data, and engagement analytics.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Suppression Management',
        tooltip:
          'Show recipient mailbox providers that you’re a whitehat sender by managing recipients who no longer want to receive your emails.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Dedicated IP Addresses',
        tooltip:
          'Own your reputation with a dedicated IP address, and then automate your IP warmup and manage additional IP addresses with ease.',
        free: false,
        essentials: false,
        pro: '1 Included*',
        premier: '1 Included*',
      },
      {
        name: 'Automated, dedicated IP warm up',
        tooltip:
          'Automate the gradual increase of email traffic on your dedicated IP address to promote higher delivery rates.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
      {
        name: 'Dedicated IP Pooling',
        tooltip:
          'Control your sending across multiple dedicated IP addresses by grouping them together.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
      {
        name: 'Domain Authentication (SPF/DKIM)',
        tooltip:
          'Show email providers that Twilio SendGrid has permission to send emails on your behalf with SPF record and custom DKIM creation.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Link Branding',
        tooltip:
          'Customize link URLs to maintain tracking and ensure proper branding.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Reverse DNS',
        tooltip:
          'Improve email deliverability by verifying the IP address you are sending from is connected to your domain.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
      {
        name: 'Universal Links',
        tooltip:
          "Enhance email recipients' mobile experience and maintain click tracking with deep link configuration.",
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
    ],
  },
  {
    featureTitle: 'Actionable analytics',
    subFeatures: [
      {
        name: 'Real-Time Analytics',
        tooltip:
          'See how your emails perform with comprehensive email analytics, available in your personal dashboard or via API.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Deliverability Insights',
        tooltip:
          'Gain actionable insights to optimize your email program with the Deliverability Insights dashboard.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Bounce and Block Classifications',
        tooltip:
          'Categorization of cryptic bounce responses into 7 classifications that you can understand and take action upon.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
      {
        name: 'Engagement Tracking',
        tooltip: 'Track delivered, click, open, and unsubscribe rates.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'ISP Feedback Loop Data',
        tooltip: 'See data on bounce rate, spam, and blocked reporting.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Advanced Statistics',
        tooltip:
          'Compare email data by device, browser, ISP, geolocation, and email categories.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Subuser Comparison Statistics',
        tooltip:
          'Compare statistics by subuser to understand how your audience is engaging with your email. ',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
      {
        name: 'Searchable Email Activity',
        tooltip:
          'Expedite the email delivery troubleshooting process with sequential event organization by message, advanced search and filtering, and CSV exporting.',
        free: '3 days included',
        essentials: '3 days included',
        pro: '7 days of history',
        premier: '7 days of history**',
      },
      {
        name: 'Additional Email Activity History',
        tooltip:
          'Search and filter your email activity up to 30 days in the past with the purchase of additional email activity history.',
        free: false,
        essentials: 'Available\nfor purchase',
        pro: 'Available\nfor purchase',
        premier: 'Available\nfor purchase***',
      },
      {
        name: 'Event Webhook',
        tooltip:
          'Absorb events from your Twilio SendGrid account to create a customized analytics dashboard, set up triggered email campaigns, and insert dynamic data.',
        free: '1 Included',
        essentials: '2 Included',
        pro: '5 Included',
        premier: '5 Included',
      },
      {
        name: 'Inbound Parse Webhook',
        tooltip:
          'Parse the contents and attachments of incoming emails to manage 2-way conversations, or receive uploads from email replies.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
    ],
  },
  {
    featureTitle: 'Expertise and Support',
    subFeatures: [
      {
        name: 'Technical Support',
        tooltip:
          'Reach out to our knowledgeable support for actionable recommendations.',
        free: 'Ticket support',
        essentials: 'Ticket &\n chat support',
        pro: 'Ticket, chat, &\nphone support',
        premier: 'Ticket, chat, &\nphone support',
      },
      {
        name: 'Guaranteed Support Response Times',
        tooltip:
          'Gain peace of mind with guaranteed response times by incident priority.',
        free: false,
        essentials:
          'P1: 3 business hrs\nP2: 6 business hrs\nP3: 9 business hrs',
        pro: 'P1: 1 hr (24/7)\nP2: 2 business hrs\nP3: 3 business hrs',
        premier: 'P1: 1 hr (24/7)\nP2: 2 business hrs\nP3: 3 business hrs',
      },
      {
        name: 'Access to Expert Services',
        tooltip:
          'Add an email expert to your team to help you build a strong sender reputation and optimize your strategy as you grow.',
        free: false,
        essentials: 'Available\nfor purchase',
        pro: 'Available\nfor purchase',
        premier: 'Available\nfor purchase',
      },
      {
        name: 'Access to Personalized Support',
        tooltip:
          'Add a technical account manager to your team for the highest level of proactive technical support.',
        free: false,
        essentials: 'Available\nfor purchase',
        pro: 'Available\nfor purchase',
        premier: 'Available\nfor purchase',
      },
      {
        name: 'Expert Email Program Management',
        tooltip:
          'Partner with email pros to offer product expertise and act as an extension of your program.',
        free: false,
        essentials: false,
        pro: false,
        premier: 'Available\nfor purchase',
      },
    ],
  },
  {
    featureTitle: 'Productive collaboration',
    subFeatures: [
      {
        name: 'Dynamic Templates',
        tooltip:
          'Send personalized content with real-time design editing, point-to-click HTML rendering, and conditional testing.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Email Content Testing',
        tooltip:
          'Test your Dynamic Templates for inbox rendering, link validity, and performance against spam filters.',
        free: false,
        essentials: false,
        pro: '60 credits/mo\nMore for purchase',
        premier: '500 credits/mo\nMore for purchase',
      },
      {
        name: 'Teammate Permissions',
        tooltip:
          'Invite additional users to your account with specific predefined access.',
        free: '1 Teammate',
        essentials: '1 Teammate',
        pro: '1,000 Teammates',
        premier: '1,000 Teammates',
      },
      {
        name: 'API Key Permissions',
        tooltip:
          'Uniquely set API keys with admin, read-only, or precise access settings by feature to limit your exposure to risk.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Subuser Management',
        tooltip:
          'Segment your sending, assign permissions and credit limits, as well as view separate statistics programmatically or in the UI.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
    ],
  },
  {
    featureTitle: 'Privacy and Security',
    subFeatures: [
      {
        name: 'Two-Factor Authentication',
        tooltip:
          'Require authentication beyond a username and password when logging into your Twilio SendGrid account.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'IP Access Management',
        tooltip:
          'Whitelist IP addresses so only your account users can access your account.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'TLS Encryption',
        tooltip:
          'Increase the security of your emails by using opportunistic or enforced TLS secure protocols.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'SOC 2 Type II Certification',
        tooltip:
          'Safeguard your data with Twilio SendGrid, which has been certified by recognized industry organizations for its rigorous controls.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'GDPR Compliance',
        tooltip:
          'Maintain the highest privacy and data protection with our GDPR compliance.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Event Webhook Security',
        tooltip:
          'Secure your data ingest with signed requests or OAuth 2.0 authorization.',
        free: true,
        essentials: true,
        pro: true,
        premier: true,
      },
      {
        name: 'Single Sign-On ',
        tooltip:
          'Integrate Twilio SendGrid into your established and secure SSO platform to centrally manage user permissions.',
        free: false,
        essentials: false,
        pro: true,
        premier: true,
      },
    ],
  },
];
